import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { CartScopeEq } from '@/models/cart/group/scope'
import FreeAreaService from '@/services/free-area/free-area'
import OrderCompleteFreeAreaService from '@/services/free-area/order/order-complete-free-area'
import AppId from '@/util/appid'
import { OrderService, OrderSource } from '@spa/services/order'

export interface OrderCompleteServiceLocator {
  readonly behavior: BehaviorConfig
  readonly freeAreaService: FreeAreaService
  readonly orderService: OrderService
}

const createForBrand = (brandName: string): OrderCompleteServiceLocator => {
  return {
    behavior: BehaviorConfig.createFromBrand(brandName),
    freeAreaService: FreeAreaService.createFromBrandName(brandName, OrderCompleteFreeAreaService.forBrand),
    orderService: OrderService.create({
      appId: AppId.getByBrandName(brandName),
      orderSource: OrderSource.asUndefined(),
    }),
  }
}
const forHost: OrderCompleteServiceLocator = {
  behavior: new BehaviorConfig(),
  freeAreaService: FreeAreaService.createForHost(OrderCompleteFreeAreaService.forHost),
  orderService: OrderService.create({
    appId: AppId.getHostId(),
    orderSource: OrderSource.asUndefined(),
  }),
}

/**
 * ブランドスコープ以外では、一律ホストAppIdを利用する
 * @see https://github.com/my-color/front/issues/3934#issuecomment-644511220
 */
export const selectLocatorByScope = (scope: CartScopeEq): OrderCompleteServiceLocator => {
  if (scope.kind.isBrand) {
    return createForBrand(scope.value.toString())
  }

  return forHost
}
